import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitDown1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowSplitDown1"><Path d="M13 11.5859L19 17.5859V14H21V21H14V19H17.5859L12 13.4141L6.41406 19H10V21H3V14H5V17.5859L11 11.5859V3H13V11.5859Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowSplitDown1;
